var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "stats"
  }, [_c('article', {
    staticClass: "meta_row"
  }, [_c('p', {
    staticClass: "meta_label"
  }, [_vm._v(" Block "), _c('Tooltip', {
    attrs: {
      "content": "A scalar value equal to the number of ancestor blocks."
    }
  })], 1), _c('div', {
    staticClass: "meta_value values"
  }, [_vm._v(" " + _vm._s(_vm.block.number) + " "), _c('div', {
    staticClass: "block_link"
  }, [_vm.block.number > 0 ? _c('router-link', {
    attrs: {
      "to": "/evmblock/".concat(_vm.block.number - 1)
    }
  }, [_c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on;
        return [_c('fa', _vm._g({
          attrs: {
            "icon": "arrow-left",
            "color": "#c4c4c4"
          }
        }, on))];
      }
    }], null, false, 1999135174)
  }, [_c('div', [_c('p', [_vm._v(" " + _vm._s(_vm.block.number - 1) + " ")])])])], 1) : _vm._e()], 1), _c('div', {
    staticClass: "block_link"
  }, [_c('router-link', {
    attrs: {
      "to": "/evmblock/".concat(_vm.block.number + 1)
    }
  }, [_c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref2) {
        var on = _ref2.on;
        return [_c('fa', _vm._g({
          attrs: {
            "icon": "arrow-right",
            "color": "#c4c4c4"
          }
        }, on))];
      }
    }])
  }, [_c('div', [_c('p', [_vm._v(" " + _vm._s(_vm.block.number + 1) + " ")])])])], 1)], 1)])]), _c('article', {
    staticClass: "meta_row"
  }, [_c('p', {
    staticClass: "meta_label"
  }, [_vm._v(" Accepted "), _c('Tooltip', {
    attrs: {
      "content": "This block's inception date and time."
    }
  })], 1), _c('div', {
    staticClass: "meta_value values"
  }, [_c('p', {
    staticClass: "date"
  }, [_c('fa', {
    staticClass: "time_icon",
    attrs: {
      "icon": ['far', 'clock']
    }
  }), _c('span', {
    staticClass: "timestamp"
  }, [_vm._v(_vm._s(_vm._f("fromNow")(_vm.date)) + " (" + _vm._s(_vm.date.toLocaleString()) + ")")])], 1)])]), _c('article', {
    staticClass: "meta_row"
  }, [_c('p', {
    staticClass: "meta_label"
  }, [_vm._v(" Transactions "), _c('Tooltip', {
    attrs: {
      "content": ""
    }
  })], 1), _c('div', {
    staticClass: "meta_value values"
  }, [_vm.block.transactions.length === 0 ? [_vm._v("There are no transactions for this block.")] : [_vm._v(" " + _vm._s(_vm._f("pluralize")(_vm.block.transactions.length, 'transaction')) + " ")]], 2)]), _c('article', {
    staticClass: "meta_row"
  }, [_c('p', {
    staticClass: "meta_label"
  }, [_vm._v(" Atomic Txs "), _c('Tooltip', {
    attrs: {
      "content": ""
    }
  })], 1), _c('div', {
    staticClass: "meta_value values"
  }, [_vm.block.atomicTransactions.length === 0 ? [_vm._v("There are no atomic transactions for this block.")] : [_vm._v(_vm._s(_vm._f("pluralize")(_vm.block.atomicTransactions.length, 'cross-chain transfer')))]], 2)]), _c('article', {
    staticClass: "meta_row"
  }, [_c('p', {
    staticClass: "meta_label"
  }, [_vm._v(" Gas Used "), _c('Tooltip', {
    attrs: {
      "content": "A scalar value equal to the total gas used by all transactions in this block."
    }
  })], 1), _c('div', {
    staticClass: "meta_value values"
  }, [_vm._v(" " + _vm._s(_vm.block.gasUsed.toLocaleString()) + " gas ")])]), _c('article', {
    staticClass: "meta_row"
  }, [_c('p', {
    staticClass: "meta_label"
  }, [_vm._v(" Gas Limit "), _c('Tooltip', {
    attrs: {
      "content": "A scalar value equal to the current limit of gas expenditure per block."
    }
  })], 1), _c('div', {
    staticClass: "meta_value values"
  }, [_vm._v(" " + _vm._s(_vm.block.gasLimit.toLocaleString()) + " gas ")])]), _c('article', {
    staticClass: "meta_row"
  }, [_c('p', {
    staticClass: "meta_label"
  }, [_vm._v(" Hash "), _c('Tooltip', {
    attrs: {
      "content": ""
    }
  })], 1), _c('div', {
    staticClass: "meta_value values"
  }, [_vm._v(" " + _vm._s(_vm.block.hash) + " ")])]), _c('article', {
    staticClass: "meta_row"
  }, [_c('p', {
    staticClass: "meta_label"
  }, [_vm._v(" Parent Hash "), _c('Tooltip', {
    attrs: {
      "content": "Relates a block to its parent in the chain. It always points to the block with a number that is decreased by one, compared to the block it originates from. "
    }
  })], 1), _c('div', {
    staticClass: "meta_value values"
  }, [_vm._v(" " + _vm._s(_vm.block.parentHash) + " ")])]), _c('article', {
    staticClass: "meta_row"
  }, [_c('p', {
    staticClass: "meta_label"
  }, [_vm._v(" State Root "), _c('Tooltip', {
    attrs: {
      "content": ""
    }
  })], 1), _c('div', {
    staticClass: "meta_value values"
  }, [_vm._v(" " + _vm._s(_vm.block.stateRoot) + " ")])]), _c('article', {
    staticClass: "meta_row"
  }, [_c('p', {
    staticClass: "meta_label"
  }, [_vm._v(" Tx Root "), _c('Tooltip', {
    attrs: {
      "content": ""
    }
  })], 1), _c('div', {
    staticClass: "meta_value values"
  }, [_vm._v(" " + _vm._s(_vm.block.transactionsRoot) + " ")])]), _c('article', {
    staticClass: "meta_row"
  }, [_c('p', {
    staticClass: "meta_label"
  }, [_vm._v(" Receipts Root "), _c('Tooltip', {
    attrs: {
      "content": ""
    }
  })], 1), _c('div', {
    staticClass: "meta_value values"
  }, [_vm._v(" " + _vm._s(_vm.block.receiptsRoot) + " ")])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }